import { useAuthStore } from '@/app/modules/auth/stores/AuthStore';

export default defineNuxtPlugin(async () => {
  const authStore = useAuthStore();
  await useAsyncData(() => authStore.getCurrentAccount());
});
